import { render } from "./Coverphoto.vue?vue&type=template&id=599a3e76&scoped=true&ts=true"
import script from "./Coverphoto.vue?vue&type=script&lang=ts"
export * from "./Coverphoto.vue?vue&type=script&lang=ts"

import "./Coverphoto.vue?vue&type=style&index=0&id=599a3e76&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599a3e76"]])

export default __exports__